import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
export function FloatingCTA() {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      const scrollY = window.scrollY;
      const showAfter = 600;
      const checkout = document.getElementById('checkout');
      if (checkout) {
        const checkoutRect = checkout.getBoundingClientRect();
        const isNearCheckout = checkoutRect.top < window.innerHeight + 100;
        setVisible(scrollY > showAfter && !isNearCheckout);
      } else {
        setVisible(scrollY > showAfter);
      }
    };
    window.addEventListener('scroll', handleScroll, {
      passive: true
    });
    handleScroll();
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  return <AnimatePresence data-id="element-46">
      {visible && <motion.div initial={{
      y: 100,
      opacity: 0
    }} animate={{
      y: 0,
      opacity: 1
    }} exit={{
      y: 100,
      opacity: 0
    }} transition={{
      duration: 0.3,
      ease: 'easeOut'
    }} className="fixed bottom-0 left-0 right-0 z-50 p-3 md:p-4 bg-white/90 backdrop-blur-md border-t border-charcoal/10 shadow-[0_-4px_20px_rgba(0,0,0,0.08)]" data-id="element-47">
          <div className="max-w-lg mx-auto flex items-center justify-between gap-4" data-id="element-48">
            <div className="hidden sm:block" data-id="element-49">
              <p className="text-sm font-bold text-charcoal" data-id="element-50">
                The Quiet House Reset
              </p>
              <p className="text-xs text-charcoal/60" data-id="element-51">
                <span className="line-through" data-id="element-52">$27</span>{' '}
                <span className="text-muted-blue font-bold" data-id="element-53">$6.36</span>
                {' · '}76% off
              </p>
            </div>
            <a href="#checkout" onClick={e => {
          e.preventDefault();
          const target = document.getElementById('checkout');
          if (!target) return;
          const start = window.scrollY;
          const end = target.getBoundingClientRect().top + window.scrollY - 20;
          const duration = 2000;
          const startTime = performance.now();
          const easeInOutCubic = (t: number) => t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2;
          const animate = (currentTime: number) => {
            const elapsed = currentTime - startTime;
            const progress = Math.min(elapsed / duration, 1);
            window.scrollTo(0, start + (end - start) * easeInOutCubic(progress));
            if (progress < 1) requestAnimationFrame(animate);
          };
          requestAnimationFrame(animate);
        }} className="group flex-1 sm:flex-none inline-flex items-center justify-center gap-2 bg-muted-blue hover:bg-muted-blue-dark text-white text-sm md:text-base font-bold px-6 py-3 rounded-lg transition-all duration-300 shadow-md hover:shadow-lg" data-id="element-54">
              <span data-id="element-55">Get the Reset — $6.36</span>
              <ArrowRight className="w-4 h-4 group-hover:translate-x-0.5 transition-transform" data-id="element-56" />
            </a>
          </div>
        </motion.div>}
    </AnimatePresence>;
}